export default {
      id: "icon-dealer-search-input-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-dealer-search-input",
      toString: function () {
        return this.url;
      }
    }